import React from "react"
import { Stack, styled, Typography } from "@mui/material"

const StyledBlockTitle = styled(Typography)({
    fontSize: 16,
    fontWeight: 500,
    color: "#262626",
    marginBottom: 1.5
})

const StyledBlockDescription = styled(Typography)({
    fontSize: 16,
    fontWeight: 400,
    color: "#414141",
    marginBottom: 1.5,
})

const PEBlockHead = ({ icon, title, description, suffix }) => {
    return (
        <Stack spacing={1}>
            <Stack direction="row" alignItems="center" spacing={1}>
                <img alt="packaging-execution" src={`/icons/${icon}.svg`} />
                <StyledBlockTitle sx={{ flex: 1 }}>{title}</StyledBlockTitle>
                {suffix && <StyledBlockTitle>{suffix}</StyledBlockTitle>}
            </Stack>
            {description && (
                <StyledBlockDescription>
                    {description}
                </StyledBlockDescription>
            )}
        </Stack>
    )
}

export default PEBlockHead